import { Router } from "@angular/router";
import { SecurityConfig } from "../../edtell-admin/interfaces/route-security-config.interface";
import { AutocompleteInterface } from "../interfaces/autocomplete-result.interface";

export abstract class SrsSearch {
  label: string;
  security: SecurityConfig;
  abstract search(router: Router, text: string, autoCompleteObject?: any);
  abstract autocomplete(text): Promise<AutocompleteInterface<any>[]>;
}
